// Wagon highlight color logic per mode. Returns inline style + legend key.
// Bogie-imbalance markers: see hasBogieImbalance from ./bogie (drawn in Wagon / SimWagon).
export { hasBogieImbalance, BOGIE_IMBALANCE_THRESHOLD } from "./bogie";

export function wagonStyle(w, mode) {
  if (mode === "dwell") {
    const min = (w.dwell_seconds || 0) / 60;
    // 15 / 45 simulated minutes. TIME_SCALE = 30 in sim/useYardSim.js, so
    // green lasts ~30 s of real watching and amber until ~90 s.
    if (min < 15) return { bg: "#10b981", glow: "rgba(16,185,129,0.55)" };
    if (min < 45) return { bg: "#f59e0b", glow: "rgba(245,158,11,0.55)" };
    return { bg: "#f43f5e", glow: "rgba(244,63,94,0.6)" };
  }
  if (mode === "cargo") {
    if (w.cargo === "coal") return { bg: "#52525b", glow: "rgba(82,82,91,0.5)" };
    if (w.cargo === "empty")
      return {
        bg: "transparent",
        border: "1.5px dashed rgba(255,255,255,0.5)",
        glow: "rgba(255,255,255,0.2)",
        stroke: "rgba(255,255,255,0.5)",
        strokeDasharray: "3 2",
        strokeWidth: 1.5,
      };
    return { bg: "#2563eb", glow: "rgba(37,99,235,0.6)" }; // foreign
  }
  // weight
  const b = w.weight_brutto || 0;
  if (b < 30) return { bg: "#22d3ee", glow: "rgba(34,211,238,0.55)" };
  if (b < 70) return { bg: "#3b82f6", glow: "rgba(59,130,246,0.55)" };
  if (b <= 94) return { bg: "#6366f1", glow: "rgba(99,102,241,0.55)" };
  return { bg: "#e11d48", glow: "rgba(225,29,72,0.65)" };
}

export function fmtDwell(seconds, t) {
  const m = Math.floor((seconds || 0) / 60);
  if (m < 60) return `${m} ${t("minutes")}`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return `${h} ${t("hours")} ${rem} ${t("minutes")}`;
}
